import {getMethod} from '~/api'

async function get(request) {
    return await getMethod('/api/cruiseInfo', request)
}

export {get}
